import { useEffect, useState } from "react";
import { getCourseBatch } from "../Services/Api";

export function BulkRegistration() {
  const [course, setCourse] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getCourseBatch();
        setCourse(data.courses || []);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);


  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center py-10">
      {/* Header */}
      <div
        className="text-white rounded-lg px-8 py-6 text-center w-[80%] mb-10"
        style={{ backgroundColor: "rgb(93, 76, 207)" }}
      >
        <h1 className="text-3xl font-bold">Course Purchase Portal</h1>
        <p className="mt-2 text-blue-100">
          Browse our courses, select one, and upload your Excel sheet to complete your purchase
        </p>
      </div>

      {/* Main Section: Courses + Upload */}
      <div className="flex w-[80%] gap-8">
        {/* Left: Courses */}
        <div className="w-1/2 bg-white rounded-xl shadow-md p-6">
          <h2 className="text-xl font-semibold mb-4">Available Courses</h2>
          <div className="space-y-4">
            {course.map((item, index) => (
              <div
                key={index}
                className="flex justify-between items-center p-4 border rounded-lg hover:shadow-lg transition-shadow"
              >
                <div>
                  <h3 className="font-semibold text-gray-800">{item.course_name}</h3>
                  <p className="text-sm text-gray-500">{item.description}</p>
                </div>
                <span className="text-blue-700 font-bold">₹{item.course_price}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Right: Upload Section */}
        <div className="w-1/2 bg-white rounded-xl shadow-md p-6 flex flex-col items-center justify-center">
          <h2 className="text-xl font-semibold mb-4">Upload Excel Sheet</h2>

          <div className="border-2 border-dashed border-gray-300 rounded-lg h-64 w-full flex flex-col items-center justify-center text-center hover:border-blue-500 transition-colors">
            <p className="text-gray-500 mb-3">
              Drag & drop your Excel sheet here or click to browse
            </p>
            <label className="cursor-pointer">
              <input type="file" accept=".xls,.xlsx" hidden />
              <span className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700">
                Browse Files
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
